import { useContext } from "react";
import { MakeContext } from "../context";

export const useMake = () => useContext(MakeContext);
